import { makeEntityScaffold } from '@classpass/saga-tools';

export const userActionCampaign = makeEntityScaffold(
  'SAGA.API.USER_ACTION_CAMPAIGN',
  (client, token) => client.userActionCampaign.referral(token),
  { defaultKey: 1 }
);

export const userActionCampaignEvent = makeEntityScaffold(
  'SAGA.API.USER_ACTION_CAMPAIGN_EVENT',
  (client, event, params) => client.userActionCampaign.event(event, params),
  { defaultKey: 1 }
);
